import React from "react";
import { lang } from "../lang";
import TaskActionButton from "./TaskActionButton"; // Import TaskActionButton

// Component for task action buttons (delete, add child, etc.)
function TaskActions({
  task, // This is the parent task when adding a child
  isChildTask,
  onDeleteTask,
  onAddChildTask,
  onSelectTask, // This is the selectTask(id, level) function from useTaskNavigation
  defaultTaskDuration,
  taskRefs,
}) {
  const handleAddChild = (e) => {
    // e.stopPropagation(); // TaskActionButton handles stopPropagation
    const newTaskId =
      Date.now().toString() + "-" + Math.random().toString(36).substr(2, 9);
    const newTask = {
      id: newTaskId,
      name: lang.task.newSubtask,
      duration: defaultTaskDuration,
      remaining: defaultTaskDuration,
      paused: true,
      completed: false,
      children: [],
      isRest: false,
      tags: [],
      notes: "",
      isNew: true,
    };
    if (process.env.NODE_ENV === "development") {
      console.log(
        "[TaskActions] Adding child subtask under:",
        task.id,
        newTask
      );
    }

    onAddChildTask(task.id, newTask);

    if (onSelectTask) {
      if (process.env.NODE_ENV === "development") {
        console.log(
          "[TaskActions] Calling onSelectTask for parent:",
          task.id,
          "to ensure column is open."
        );
      }
      onSelectTask(task.id);
    }

    setTimeout(() => {
      if (
        taskRefs.current &&
        taskRefs.current[newTaskId] &&
        typeof taskRefs.current[newTaskId].focus === "function"
      ) {
        if (process.env.NODE_ENV === "development") {
          console.log(
            "[TaskActions] Attempting to focus new child task:",
            newTaskId
          );
        }
        taskRefs.current[newTaskId].focus();
      } else {
        if (process.env.NODE_ENV === "development") {
          console.warn(
            "[TaskActions] Could not focus new child task. Ref not found or not focusable:",
            newTaskId
          );
        }
      }
    }, 100);
  };

  const handleDelete = (e) => {
    // e.stopPropagation(); // TaskActionButton handles stopPropagation
    if (process.env.NODE_ENV === "development") {
      console.log("[TaskActions] Deleting task:", task.id);
    }
    onDeleteTask(task.id);
  };

  const showAddSubtaskButton = !task.isRest;

  return (
    <div className="task-actions">
      {showAddSubtaskButton && (
        <TaskActionButton
          className="add-subtask task-action-button-text"
          onClick={handleAddChild}
          title={lang.task.addSubtaskAlt}
        >
          {lang.task.addSubtaskAlt}
        </TaskActionButton>
      )}
      <TaskActionButton
        className="delete-task task-action-button-text"
        onClick={handleDelete}
        title={lang.task.deleteAlt}
      >
        {lang.task.deleteAlt}
      </TaskActionButton>
    </div>
  );
}

export default TaskActions;
